var _defs, _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcpLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 528.9 327",
    style: {
      enableBackground: "new 0 0 528.9 327"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tcp-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear",
    x1: "50.5%",
    y1: "0%",
    x2: "51%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffb600"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t#path{\n\t\t\tfill: none;\n\t\t\tstroke: url(#linear);\n\t\t\tstroke-dasharray: 1353;\n\t\t\tstroke-dashoffset: 1353;\n\t\t\tstroke-width: 40;\n\t\t\tstroke-linecap: butt;\n\t\t\tanimation: path 2s linear infinite;\n\t\t}\n\n\t\t@keyframes path{\n\t\t\t0%{stroke-dashoffset: 1353;}\n\t\t\t50%{stroke-dashoffset: 0;}\n\t\t\t100%{stroke-dashoffset: -1353;}\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "st0",
    d: "M227.2,168.7c-19.7,28.6-51.3,58.5-83.4,58.5h-0.2c-26-0.1-50.4-9.9-68.7-27.7 c-18.1-17.6-28.2-40.9-28.5-65.8c-0.3-26.1,9.4-50.5,27.2-68.6c18.6-18.8,43.9-28.8,73.2-28.8c17.1,0,33.3,4.9,49.7,15.1 c7.4,4.6,13.6,9.6,18.6,14.4c5.6,5.3,9.6,10.3,12.5,13.8l3.3,4c7,8,44.9,65.8,47.2,69.2l1.2,1.7c5.8,9.5,10.7,16.9,19.9,28 c10.8,13.1,21.3,26,37.3,34.4l1.9,1c13.7,6.8,28.2,10.3,42.9,10.3c17,0,33.5-4.7,48.9-13.9c23.6-14.1,39.4-37.1,44.6-64.9 c5-27-1.3-55-16.8-74.9c-18.4-23.6-48.7-38.2-79-38.2c-21.2,0-40.8,6.9-56.7,20c-37.4,30.9-36.8,63.8-36.4,85.7c0,2,0.1,3.8,0.1,5.5c-0.2,16.3,0.4,73.9,1.3,156.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcpLoading);
export default __webpack_public_path__ + "static/media/tcp-loading.23a9d19503c6b50e19b51ecc49db3305.svg";
export { ForwardRef as ReactComponent };